import auditLogsFetch from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";
export const AUDIT_TRACKING_TOKEN_KEY = "AUDIT_ID_TOKEN";

const auditLogsService = {};

auditLogsService.getAuditToken = () => {
  return auditLogsFetch({
    url: `${env.API_MSP}/users/audit-token`,
    method: "post",
    data: {
      reNew: true,
    },
  });
};

auditLogsService.listMsplogisticAuditLogs = ({ params }) => {
  const {
    page = 1,
    sizePerPage = 10,
    sort = "-maker_date",
    keywords = "",
    fields = "",
    expand = "",
    columnFilter = {},
  } = params || {};

  return auditLogsFetch({
    url: `/services/mspauditlog/trackings`,
    method: "get",
    params: {
      "filter[app_code]": "msplogistic",
      ...columnFilter,

      page,
      "per-page": sizePerPage,
      sort,
      keywords,
      expand,
      fields,
    },
  });
};

auditLogsService.listMsplogisticUsers = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  return auditLogsFetch({
    url: `${env.API_MSP}/users`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || "",
    },
  });
};
auditLogsService.exportAuditLogs = ({ params }) => {
  const {
    page = 1,
    sizePerPage = 10,
    sort = "-maker_date",
    keywords = "",
    fields = "",
    expand = "",
    columnFilter = {},
  } = params || {};

  return auditLogsFetch({
    url: `${env.API_MSP}/audit-logs/export`,
    method: "get",
    params: {
      "filter[app_code]": "msplogistic",
      ...columnFilter,
      page,
      "per-page": sizePerPage,
      sort,
      keywords,
      expand,
      fields,
    },

    responseType: "blob",
  });
};
export default auditLogsService;
